// Version : 0.0.1
// Author : SATHISH
// LastEdit : SHIYAM
// MODFIED DATE: 26-09-2025
// Last ADD : Removed excel related code and added command lines

/* eslint-disable import/no-anonymous-default-export */
import { docodeHexResponse } from '../../_common/common.utils';
import PreCloseReportActionTypes from './preclose-loan-report.types';

const INITIAL_STATE = {
	getPreCloseReportListResponse: null,
	getPrecloseReportListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/************** GET PRECLOSE REPORT LIST START ************************** */
		case PreCloseReportActionTypes.GET_PRECLOSE_REPORT_LIST_SUCCESS:
			return {
				...state,
				getPreCloseReportListResponse: action.payload,
				getPrecloseReportListArr: docodeHexResponse(action.payload, 'GetMemberPreCloseKey'),
			};

		case PreCloseReportActionTypes.GET_PRECLOSE_REPORT_LIST_FAILURE:
			return {
				...state,
				getPreCloseReportListResponse: action.payload,
				getPrecloseReportListArr: [],
			};

		case PreCloseReportActionTypes.GET_PRECLOSE_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getPreCloseReportListResponse: null };
		/************** GET PRECLOSE REPORT LIST END ************************** */
		default:
			return state;
	}
};
